import axios from 'axios';
import http from './HttpService';

const END_POINT = 'dashboard-users';

const login = (data) => {
  return axios.post(`${process.env.REACT_APP_BASE_URL}/login`, data);
};

const logout = (data) => {
  return axios.post(`${process.env.REACT_APP_BASE_URL}/logout`, data);
};

const addAdminUser = (data) => {
  return http.post(END_POINT, data);
};

const updateAdminUser = (id, data) => {
  return http.put(`${END_POINT}/${id}`, data);
};

const getAdminUser = (searchParams) => {
  return http.get(END_POINT, { params: searchParams });
};

const deleteAdminUser = (id) => {
  return http.delete(`${END_POINT}/${id}`);
};

const changeAdminUserStatus = (id, data) => {
  return http.patch(`${END_POINT}/change-status/${id}`, data);
};

const changeAdminOwnPassword = (data) => {
  return axios.patch(`${process.env.REACT_APP_BASE_URL}/change-password`, data);
};

const changeAdminUserPassword = (id, data) => {
  return http.patch(`${END_POINT}/change-password/${id}`, data);
};

const changeApp = (data) => {
  return http.post(`${END_POINT}/change-app`, data);
};
export default {
  login,
  addAdminUser,
  getAdminUser,
  deleteAdminUser,
  changeAdminUserStatus,
  updateAdminUser,
  changeAdminOwnPassword,
  changeAdminUserPassword,
  logout,
  changeApp,
};
